import { Component, OnInit, Output, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';
import { Utils } from 'src/app/shared/utils';
import { NgClass, NgIf } from '@angular/common';
import { HeartHeaderComponent } from '../../../../../../../shared/lista-deseos/heart-header/heart-header.component';

@Component({
    selector: 'app-volcanicparadisegalapagos',
    templateUrl: './volcanicparadisegalapagos.component.html',
    styleUrls: ['./volcanicparadisegalapagos.component.scss'],
    imports: [NgClass, NgIf, HeartHeaderComponent]
})
export class VolcanicparadisegalapagosComponent implements OnInit {

  @Output() public headerHeight: EventEmitter<any> = new EventEmitter();
  @ViewChild('header') headerRef!: ElementRef;
  @Output() public headerHeight1: EventEmitter<any> = new EventEmitter();
  @ViewChild('header1') headerRef1!: ElementRef;

  constructor(
    public companyParamsService: CompanyParamsService
  ) { }
  showMenu: boolean = false;

  ngOnInit(): void {
  }

  renderMenu() {
    this.showMenu = !this.showMenu;
  }

  goFavorites() {
    const urlFavorites: any =
      this.companyParamsService.getNameUrl() +
      '/wishlist';
    Utils.openNewTab(urlFavorites);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      var height = this.headerRef.nativeElement.offsetHeight;
      this.headerHeight.emit(height);
      var height1 = this.headerRef1.nativeElement.offsetHeight;
      this.headerHeight1.emit(height1);
    }, 300);
  }

}
